import {
  gsap
} from 'gsap';
import {
  objectOrientation
} from '../../utilities/helpers';
import {
  bgViewer
} from '../../utilities/bg-viewer';

export function loadIntro(body, viewerBg) {
  // This is great start  - but I need to review this in the context of each page - and in some instances the colours choices are weak
  // unless on other non home pages I have athat solid coclour - about red - resources blue. That could work :)

  // console.log("loadIntro - should be called once on intial load of website < this should be loading immediately!");
  // console.log("viewerBg", viewerBg);

  let gradientLine = body.querySelector(".line");
  let head = body.querySelector("header"); // main header
  let header = body.querySelector(".header__nav"); // nav container << review the usage of this!
  let headerNav = body.querySelector(".header-nav"); //actaul nav
  let headerLogo = body.querySelectorAll(".logo a"); //review usage of this selector - there are 2!
  let footer = body.querySelector("footer"); // nav container << review the usage of this!

  let main = body.querySelector("#main");
  // let bgViewer = body.querySelector("#bg-viewer"); //the bg area that is dimmed on load

  console.log("header", header)


  let viewerBgInfo = viewerBg.querySelector(".bg-viewer__details"); //the bg area that is dimmed on load

  // bgViewer(viewerBg);
  bgViewer(viewerBg);

  const loadIntrotl = gsap.timeline({
    defaults: {
      duration: 2,
      ease: "power4.out",
    },
  });

  // to do d - ensure all the items are intially hiden - and then fade in
  // via jas -+ chang the class to ensrue the fade doesn't happen ever again


  //As I've now figure that not showing the logo and white bg on the home page; we need to alter this animation accordingly
  // if (body.classList.contains("home")) {


  //   loadIntrotl
  //     .fromTo(headerLogo, {
  //       color: "transparent",
  //     }, {
  //       color: "white",
  //     }, "0")
  //     .fromTo(header, {
  //       y: "40dvh",
  //       opacity: 0,
  //     }, {
  //       y: "45dvh",
  //       opacity: 1,
  //     }, "<1")
  //     .add(function () {
  //       setClass(gradientLine)
  //     })
  //     .fromTo(header, {
  //       y: "45dvh",
  //     }, {
  //       y: "0",
  //       duration: 0.5,
  //       // ease: "power4.out", - review this ease - I could addopt different eases for different compontents potentially
  //     }, "<1")
  //     .to(headerLogo, {
  //       color: "black",
  //       opacity: 0,
  //     }, "<")
  //     .to(head, {
  //       background: "transparent",
  //       duration: 0.5,
  //       // ease: "power4.out", - review this ease - I could addopt different eases for different compontents potentially
  //     }, "<")
  //     .to(footer, {
  //       opacity: 1,
  //     }, "<0.2")
  //     .fromTo(gradientLine, {
  //       opacity: 0,
  //     }, {
  //       opacity: 1,
  //     }, "<0.2")
  //     .to(viewerBg, {
  //       opacity: 0.4, // review
  //     }, "<0.2")
  //     .to(main, { // we seem to be already animating this or some other elemebt - i.e the home intro text?!
  //       opacity: 1,
  //     }, "<0.2")
  //     // .fromTo(headerLogo, {
  //     //   opacity: 0,
  //     // }, {
  //     //   opacity: 1,
  //     // }, "<0.2")
  //     .fromTo(headerNav, {
  //       opacity: 0,
  //     }, {
  //       opacity: 1,
  //     }, "<1")
  //     .fromTo(viewerBgInfo, {
  //       opacity: 0,
  //     }, {
  //       opacity: 1,
  //     }, "<1")




  // } else {
  //review this.



  // console.log("timeline starts");

  loadIntrotl
    .fromTo(headerLogo, {
      color: "transparent",
    }, {
      color: "white",
    }, "0")
    .fromTo(header, {
      y: "40dvh",
      opacity: 0,
    }, {
      y: "45dvh",
      opacity: 1,
    }, "<1")
    .add(function () {
      setClass(gradientLine)
    })
    .fromTo(header, {
      y: "45dvh",
    }, {
      y: "0",
      duration: 0.5,
      // ease: "power4.out", - review this ease - I could addopt different eases for different compontents potentially
    }, "<1")
    .to(headerLogo, {
      color: "black",
    }, "<")
    .to(head, {
      background: "white",
      duration: 0.5,
      // ease: "power4.out", - review this ease - I could addopt different eases for different compontents potentially
    }, "<")
    // .to(footer, {
    //   opacity: 1,
    // }, "<0.2")
    .fromTo(gradientLine, {
      opacity: 0,
    }, {
      opacity: 1,
    }, "<0.2")
    .to(viewerBg, {
      opacity: 0.4, // review
    }, "<0.2")
    .to(main, { // we seem to be already animating this or some other elemebt - i.e the home intro text?!
      opacity: 1,
    }, "<0.2")
    // .fromTo(headerLogo, {
    //   opacity: 0,
    // }, {
    //   opacity: 1,
    // }, "<0.2")
    .fromTo(headerNav, {
      opacity: 0,
    }, {
      opacity: 1,
    }, "<1")
    .fromTo(viewerBgInfo, {
      opacity: 0,
    }, {
      opacity: 1,
    }, "<1")

  // } // if body


  function setClass(gradientLine) {
    // console.log("setClass", gradientLine);
    gradientLine.classList.remove("--loading");
  }

}

export function clearTransform(element) {
  console.log("clearTransform", element);
  // the following function removes the transforms from an element
  //use case: ensuring our fixed positins reemain fixed to parent; and not new transform model
  element.style.transform = "initial";
  // console.log("clearTransforms Done");
}

export function updateBackButton(container, url) {
  // console.log("updateBackButton", container, url);
  var backLink = container.querySelector('.nav--back-link a');
  backLink.setAttribute('href', url);
  // backLink.style.backgroundColor = "red";
}

export function filterPostView(activePost, containerType, container, initiator) {
  // console.log("filterPostView", activePost, containerType, container, initiator);
  // console.log("activePost", activePost); // current active post
  // console.log("containerType", containerType); // barba container type - current or next
  // console.log("container", container); // container.next or container.current itself
  // console.log("initiator", initiator); // where this function is being called from - home, archive or single


  // try and write a description in regadrs to waht this function does
  // this function is used to filter the post view in the resources section
  // it is used to filter the post view in the resources section


  let contentSelector;

  if (initiator == "home") { // the intiator could be home and appying to the next namspace though...
    contentSelector = "[data-panel-content]";


  } else if (initiator == "archive") {

    if (containerType == "pre-transform") {
      contentSelector = ".article__content";
    } else if (containerType == "post-transform") {
      contentSelector = "[data-panel-content]";
    }

  } else if (initiator == "single") {
    // thiis snot been tesed - so selecters may beed adjust same as the catogery view items

    if (containerType == "pre-transform") {
      contentSelector = ".article__content";
    } else if (containerType == "post-transform") {

      contentSelector = "[data-panel-content]";
    }
  }

  let content = container.querySelector(contentSelector),
    activePostLink = content.querySelector('li[data-post-id="' + activePost + '"]'),
    activePostCategory = content.querySelector('li[data-post-id="' + activePost + '"]').closest("[data-resource-category]").getAttribute("data-resource-category"),
    activePostCategoryLink = content.querySelector('li[data-body-nav-link="' + activePostCategory + '"]'); // one of the nave links (9in the body)


  console.log("activePostCategory:", activePostCategory);
  console.log("activePostCategoryLink:", activePostCategoryLink);

  if ((initiator == "archive") && (containerType == "post-transform")) {
    // console.log("if intiator archive - and container type is post-transform then its sthe post transform container on the single page");

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');
    objectOrientation(resourceCategoriesUl) // review - the need to have this run on the barbar pre-transform as well...
    resourcesView(content, initiator); // type aka initiator <Do I need this; I ggues so?
    // also activate the category panel that was active
    activePostCategoryLink.click(); // does this create a scroll event that conflicts with the scroll to the top of the page in barba??
    // // and also activate the post item that was active
    activePostLink.click(); // does this create a scroll event that conflicts with the scroll to the top of the page in barba?

  } else if ((initiator == "home") && (containerType == "post-transform")) {

    console.log("if intiator home - and container type is post-transform then its sthe post transform container on the archive page");
    // shit starts failing here.... 

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');

    console.log("resourceCategoriesUl", resourceCategoriesUl);
    console.log("content", content);
    console.log('initiator', initiator);

    objectOrientation(resourceCategoriesUl) // review - the need to have this run on the barbar pre-transform as well...
    resourcesView(content, initiator); // type aka initiator


    console.log("activePostCategoryLink", activePostCategoryLink);
    console.log(" about to click on an object - but maybe it hasn't had its click event assigned yet?")
    activePostCategoryLink.click(); // reviest this it may not trigger the reight thing when wer ar in the /resources page archive and setting theintiital view in the article__content

  } else if ((initiator == "single") && (containerType == "post-transform")) {

    // console.log("if intiator  is single - and containterType = post-transform");

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');

    objectOrientation(resourceCategoriesUl) // review - the need to have this run on the barbar pre-transform as well...
    resourcesView(content, initiator); // type aka initiator <Do I need this; I ggues so?

    // also activate the category panel that was active
    activePostCategoryLink.click();
    // // and also activate the post item that was active
    activePostLink.click();

  } else if (initiator == "archive") {
    //review but I think this is sufficient 

    // if not pret-transfor this would be p
    console.log("if intiator archive - we need to trigger the active post link and not just the category link");
    // but it might not have a category link. So form the categoiry archie I clicked on a post link
    activePostCategoryLink.click(); // review
    activePostLink.click(); // reviest this it may not trigger the reight thing when wer ar in the /resources page archive and setting theintiital view in the article__content


  } else if (initiator == "single") {

    console.log("CODE NEEDS FINISHEING  if intiator  is single - so add in the relevant js here");

  }
}

export function filterCategoryView(activeCategory, containerType, container, initiator) {

  // console.log("filterCategoryView", activeCategory, containerType, container, initiator);
  // console.log("filterCategoryView");
  // console.log("activeCategory", activeCategory); // current active category
  // console.log("containerType", containerType); // barba container type - current or next
  // console.log("container", container); // container.next or container.current itself
  // console.log("initiator", initiator); // where this function is being called from - home, archive or single

  let contentSelector;

  if (initiator == "home") { // the intiator could be home and appying to the next namspace though...
    contentSelector = "[data-panel-content]";
  } else if (initiator == "archive") {

    if (containerType == "pre-transform") {
      contentSelector = ".article__content";
    } else if (containerType == "post-transform") {
      contentSelector = "[data-panel-content]";

    }

  } else if (initiator == "single") {
    // thiis snot been tesed - so selecters may beed adjust same as the catogery view items

    if (containerType == "pre-transform") {
      contentSelector = ".article__content";
    } else if (containerType == "post-transform") {

      contentSelector = "[data-panel-content]";
    }
  }

  let content = container.querySelector(contentSelector),
    activePostCategoryLink = content.querySelector('li[data-body-nav-link="' + activeCategory + '"]'); // one of the nave links (9in the body)

  if ((initiator == "archive") && (containerType == "post-transform")) {
    // console.log("if intiator archive - and container type is post-transform then its sthe post transform container on the single page");

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');
    objectOrientation(resourceCategoriesUl);
    resourcesView(content, initiator);

    activePostCategoryLink.click(); // review

  } else if ((initiator == "home") && (containerType == "post-transform")) {
    // console.log("filterCategoryView: if intiator home - and container type is post-transform then its sthe post transform container on the archive page");

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');

    objectOrientation(resourceCategoriesUl);
    // this is the post transform container  
    resourcesView(content, initiator); // type aka initiator


  } else if ((initiator == "single") && (containerType == "post-transform")) {

    // console.log("if intiator  is single - and containterType = post-transform - review all this code maybe wrong");

    let resourceCategoriesUl = content.querySelector('.panel__body[data-resource-content="archive"] ul');

    objectOrientation(resourceCategoriesUl)
    resourcesView(content, initiator);

    activePostCategoryLink.click(); // review
    // activePostLink.click(); //review if this is the right thing to do?


  } else if (initiator == "archive") {
    //REVIEW this is does it even catch1?
    console.log("CODE NEEDS FINISHEING if intiator archive - and nothing else so different to the post transform container");
    // activePostLink.click(); // reviest this it may not trigger the reight thing when wer ar in the /resources page archive and setting theintiital view in the article__content
    activePostCategoryLink.click(); // re

  } else if (initiator == "single") {

    console.log("CODE NEEDS FINISHEING  made the active link black - intiaotr Single", activePostCategoryLink);
    activePostCategoryLink.click(); // re  
  }

} //filterCategoryView

export function resourcesView(resources, type) {

  console.log("resourcesView", resources);
  // console.log("Type:", type); // aka intitiator

  //there are two area of links - the top nav and the body nav - ensure they all work in cohesion
  let resourcesNav = resources.querySelectorAll('li[data-nav-link]'),
    resourcesBodyNav = resources.querySelectorAll('li[data-body-nav-link]'),
    resourcesPosts = resources.querySelectorAll('div[data-resource-content="post"]'),
    root = document.querySelector(':root');

  // console.log("resourcesNav", resourcesNav);
  // console.log("resourcesBodyNav", resourcesBodyNav);
  // console.log("resourcesPost", resourcesPosts);

  resourcesNav.forEach((item) => {

    item.addEventListener('click', function (event) {

      let item = event.target.closest('li'),
        sidePanelNavLink = item.getAttribute('data-nav-link'), // this will be idle initially
        categorySlug = item.getAttribute('data-nav-link'); // save value as below

      if (item.classList.contains("--active")) {
        // this item is already active - so we need to close the side panel
        // console.log("item is not active anymore", item);
        item.classList.remove("--active");
        //find other actiuve items
        resourcesNav.forEach((resourcesNavItem) => {
          resourcesNavItem.classList.remove("--active");
        });
        resourcesBodyNav.forEach((resourcesBodyNavItem) => {
          resourcesBodyNavItem.classList.remove("--active");
        });
        //nav is NOT active
        resources.classList.remove("--nav-active");
        // remove the value to ensure its caught in barbna transition
        resources.removeAttribute("data-category-active");

        // we also need to remove the data attrribute from the body data-active-category=""
        document.querySelector('body').removeAttribute("data-active-category");

      } else {
        //also asign other item as active
        resourcesBodyNav.forEach((resourcesBodyNavItem) => {
          let data = resourcesBodyNavItem.getAttribute('data-body-nav-link');
          // console.log(" data-body-nav-link  > data ", data);

          if (data == sidePanelNavLink) {
            resourcesBodyNavItem.classList.add("--active");
          } else {
            resourcesBodyNavItem.classList.remove("--active");
          }
        });
        resourcesNav.forEach((resourcesNavItem) => {
          resourcesNavItem.classList.remove("--active");
        });
        //add active class to this item
        item.classList.add("--active");
        resources.classList.add("--nav-active");
        resources.setAttribute("data-category-active", categorySlug);


        // console.log("Scroll here on the category click", resources);
        // scroll to the top of the page
        //  window.scrollTo(0, 0); // review if this is appropriate - or if I need to scroll to the top of the resources container
        //  window.scrollTo({
        //   top:0,
        //  left: 0,
        //   behavior: "smooth",
        // });
        // // this current scroll is not suffice in the case of the relate posts - as the active post is not in view


        // console.log("resources.offsetHeight", resources.offsetHeight);
        // console.log("resources.offsetHeight", resources.offsetTop);

        // This is causing issues - its not scroling to the right place. Deep dive into this.
        // Currently noticing that on the archive page when lcik on the nav link- the categories - it scrolls to far up?

        // lets test 0 and not run this scroll to on archive page

        // if (type !== "archive") {

        console.log("resourcess nav each item click scroll to in barba helper");
        // need to have home and archive behaviour define differently
        if (type == "home") {
          // window.scrollTo({
          //   // top: resources.offsetHeight,
          //   top: resources.offsetTop, // see if this works instead?
          //   left: 0,
          //   behavior: "smooth",
          // });

          const panelContent = document.querySelector('.panel__content[data-panel-content=resources]'); // needs to be the active one? 
          // this is messy I've  declared this twice! - ensure its set up once - espeically if using const

          panelContent.scrollTo({
            top: resources.offsetTop, // reivew caculation! (is from arhivve and single logic - so myt need altering)
            behavior: 'smooth'
          });




        } else { // wild card on the other types; arhive and single - should be window

          window.scrollTo({
            // top: resources.offsetHeight,
            top: resources.offsetTop, // see if this works instead?
            left: 0,
            behavior: "smooth",
          });




        }

        // also set the var inthe root for the offset to be  0? because no post would be active?!
        //--active-offset-height - this may beed reviwing the with changes due to the home page now also hgaving toglges etc
        root.style.setProperty('--active-offset-height', "0px"); // this probably won't

        //review this here:
        document.querySelector('body').setAttribute('data-active-category', categorySlug);

        resourcesPosts.forEach((resourcesPost) => {
          let data = resourcesPost.getAttribute('data-resource-category');
          // console.log(" data-body-nav-link  > data ", data);

          if (data == categorySlug) {
            resourcesPost.classList.add("--active");
          } else {
            resourcesPost.classList.remove("--active");
          }
        });
      }
    });
  });

  resourcesBodyNav.forEach((item) => {

    item.addEventListener('click', function (event) {

      let item = event.target.closest('li'),
        sidePanelNavLink = item.getAttribute('data-body-nav-link'), // this will be idle initially
        categorySlug = item.getAttribute('data-body-nav-link'); // save value as below

      // console.log("resourcesBodyNav item click", item, "& Type is:", type);
      // console.log("categorySlug", categorySlug);
      // console.log("data-body-nav-link - sidePanelNavLink", sidePanelNavLink);

      if (item.classList.contains("--active")) {
        // this item is already active - so we need to close the side panel
        // console.log("item is not active anymore", item);
        item.classList.remove("--active");

        resourcesNav.forEach((resourcesNavItem) => {
          resourcesNavItem.classList.remove("--active");
        });
        resourcesBodyNav.forEach((resourcesBodyNavItem) => {
          resourcesBodyNavItem.classList.remove("--active");
        });

        //panel nav is NOT active
        resources.classList.remove("--nav-active");
        // remove the value to ensure its caught in barbna transition
        resources.removeAttribute("data-category-active");
        document.querySelector('body').removeAttribute("data-active-category");

      } else {
        // console.log("item is now active", item);
        //remove other active items

        resourcesNav.forEach((resourcesNavItem) => {

          let data = resourcesNavItem.getAttribute('data-nav-link');

          if (data == sidePanelNavLink) {
            resourcesNavItem.classList.add("--active");
          } else {
            // console.log("ELSE if (data == sidePanelNavLink) ");
            resourcesNavItem.classList.remove("--active");
          }
        });
        resourcesBodyNav.forEach((resourcesBodyNavItem) => {
          resourcesBodyNavItem.classList.remove("--active");
        });

        // console.log("do we get here?!", item)
        //add active class to this item
        item.classList.add("--active");
        //panel nav is active


        // console.log("HELLLOOO");
        // console.log("sidePanelContentResources", sidePanelContentResources);
        // console.log("resourcesPosts", resourcesPosts);

        resources.classList.add("--nav-active");
        resources.setAttribute("data-category-active", categorySlug);
        document.querySelector('body').setAttribute('data-active-category', categorySlug);

        resourcesPosts.forEach((resourcesPost) => {
          let data = resourcesPost.getAttribute('data-resource-category');
          if (data == categorySlug) {

            // console.log("data == categorySlug:", data, "==", categorySlug);
            resourcesPost.classList.add("--active");
          } else {
            // console.log("Remove active post class");

            resourcesPost.classList.remove("--active");
          }
        });
      }

    });

  });

  resourcesPosts.forEach((item) => {

    // console.log("resourcesPost item", item, "type:", type);

    let postsItems = item.querySelectorAll('li[data-post]');
    // console.log("postsItems", postsItems);
    // this would apply to the home page because the link takes yout ot eh arhicve page
    // but on the arhvie page we want to have a open/close toggle on post content + then a link to the post
    // 10th jan 25"-  makig changes to the home resources - either consolidate function split
    // or mainatin ghte type (and maybe copy same code) - althpugh I'm sure there will be some differences?
    // reivew code 
    // if (type == "_home") { // reivew + delete

    //   // see if I can just ruen the same code as archvie?
    //   postsItems.forEach((item) => {
    //     // console.log("postsItems each", item);

    //     let linkTarget = item.querySelector('a[data-active-post]'); // this not existing on the arhice - revview reasonsing

    //     // console.log("linkTarget", linkTarget);

    //     linkTarget.addEventListener('click', function (event) {

    //       // let dataActivePost = linkTarget.getAttribute('data-active-post'); // this will be idle initially
    //       // console.log("item linkTarget click", dataActivePost);
    //       let dataActivePostId = linkTarget.getAttribute('data-active-post-id'); // this will be idle initially
    //       // console.log("item linkTarget click", dataActivePostId);
    //       //assigne active post id to body (for post transform and filtering in next namespace)
    //       document.querySelector('body').setAttribute('data-active-post', dataActivePostId); // this will be idle initiall
    //       // no need to add height to the root var - as this is not needed on the home page??
    //       if (event.target.tagName.toLowerCase() == 'a') {
    //         linkTarget.classList.add("--active"); // revie

    //       }
    //     });
    //   });

    // } else 
    if ((type == "archive") || (type == "home")) {
      // console.log("type is archive  OR home");

      // this maybe be flawwed beccause on arhvie we load the post transform (old container markup) and then the article__content wiht the new toggle etc.
      postsItems.forEach((item) => {
        //  console.log("postsItems each", item);
        let linkTarget = item; //.querySelector('li[data-active-post]'); // this not existing on the arhice - revview reasonsing

        // console.log("linkTarget", linkTarget);


        linkTarget.addEventListener('click', function (event) {


          //maybe the this isn't fully opeation before the click evente is assigned? - at line 296
          console.log("Cick event Listener added", event);


          // let dataActivePost = linkTarget.getAttribute('data-post'); // this will be idle initially
          // console.log("Archive HERE: item linkTarget click", dataActivePost);
          let dataActivePostId = linkTarget.getAttribute('data-post-id'); // this will be idle initially
          // console.log("Archive HERE: item linkTarget click", dataActivePostId);
          // assigne active post id to body (for post transform and filtering in next namespace)
          document.querySelector('body').setAttribute('data-active-post', dataActivePostId); // this will be idle initiall

          if (event.target.tagName.toLowerCase() == 'a') {
            // we clicked a link 
            // this reutn statment needs propper chekcing = might cause issues tha tI'm not aware of
            //22jun 2024
            linkTarget.classList.add("--active"); // review

            console.log("we clicked a link - so don't toggle the post content?");
            console.log("REVIEW this - ensruing scroll alignmetn for the transiton is perfectt?");

            // on the home page - I think we should ensure the active item is aligned up to the top
            //10th jan 25'
            //               // start - thisis probably wrong        
            // const panelContent = document.querySelector('.panel__content[data-panel-content=resources]'); // needs to be the active one? 
            //             // this is messy I've  declared this twice! - ensure its set up once - espeically if using const
            //             // because this probably also targeted on the arhive or single - in which case needs to be either window or panel scrolli container
            //             panelContent.scrollTo({
            //               top: resources.offsetTop, // reivew caculation! (is from arhivve and single logic - so myt need altering)
            //               behavior: 'smooth'
            //             });
            //               //end - thisis probably wrong        


            return;

          } else if (event.target.tagName.toLowerCase() !== 'a') {
            // if not a link - then we need to toggle the post content
            // console.log("not a link - so toggle post content");

            if (linkTarget.classList.contains("--active")) {
              // this item is already active - so we need to close the side panel
              // console.log("item is not active anymore", linkTarget);
              linkTarget.classList.remove("--active");

            } else {
              // console.log("item is now active", linkTarget);

              postsItems.forEach((postsItem) => {
                // console.log("its remove here?");
                // postsItem.style.backgroundColor = "red";
                postsItem.classList.remove("--active");
              });

              //add active class to this item
              linkTarget.classList.add("--active");

            }

          }



          // calcuclulates scroll and offest for scroling to whe nitem active
          //home is in the panel - and archive is based on teh window/ma - i.e diff scroll container paramaters

          // if (type == "archive"){

          // let dataActivePostHeight = linkTarget.offsetHeight, // height of active item
          //   getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
          //   // Adding 3 px - that resolves the iccorect offset - possibley because the borders are not mesauresd at?
          //   applyScrollOffset = linkTarget.getBoundingClientRect().top + window.pageYOffset + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile


          // root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var

          // } else if (type == "home"){


          //   const panelContent = document.querySelector('.panel__content[data-panel-content=resources]'); // needs to be the active one? 


          //   let dataActivePostHeight = linkTarget.offsetHeight, // height of active item
          //   getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
          //   // Adding 3 px - that resolves the iccorect offset - possibley because the borders are not mesauresd at?
          //   applyScrollOffset = linkTarget.getBoundingClientRect().top + window.pageYOffset + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile


          // root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var

          //   }
          //scroll to the active item -- review all this in conjunction with the barba transitions - especially going into single etc.

          // lets tray and disable the scrolling in the post transform container - as this maybe done via ahte barba/gsap transition work
          // atm - these functions seem to be conflicting with the barba transitions - i.e the scroll to the top of the page in barba?


          // if type
          // console.log("  applyScrollOffset);
          // i need to see what body classes are available herel
          // if body class contains loading - don't scroll - during barbab transitions other scroll activites are at play

          if (document.querySelector('body').classList.contains('loading') && !document.querySelector('body').classList.contains('archive')) {
            // console.log("document.querySelector('body')", document.querySelector('body'));

            // console.log(" NO LONGER SCROLL resources views Scroll to the active item - applyScrollOffset in barba helpers", applyScrollOffset);
            // // 22 jun - this affescts the home to archive transition - so I need to review this as well

          } else {

            if (type == "archive") {

              let dataActivePostHeight = linkTarget.offsetHeight, // height of active item
                getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
                // Adding 3 px - that resolves the iccorect offset - possibley because the borders are not mesauresd at?
                // applyScrollOffset = linkTarget.getBoundingClientRect().top + window.pageYOffset + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile
                applyScrollOffset = linkTarget.getBoundingClientRect().top + window.scrollY + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile

              root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var

              window.scrollTo({
                top: applyScrollOffset,
                behavior: 'smooth'
              });
              // console.log(" ARCHIVE resources views Scroll to the active item - applyScrollOffset in barba helpers", applyScrollOffset);


            } else if (type == "home") {
              // const panelContent = document.querySelector('.panel__content.--nav-active"'); // needs to be the active one? 
              // which is the resources


              const panelContent = document.querySelector('.panel__content[data-panel-content=resources]'); // needs to be the active one? 
              //review this cnost alreadty declared (but not globally)

              let dataActivePostHeight = linkTarget.offsetHeight, // height of active item
                getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
                // Adding 3 px - that resolves the iccorect offset - possibley because the borders are not mesauresd at?
                applyScrollOffset = linkTarget.getBoundingClientRect().top + panelContent.scrollTop + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile

              root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var


              // console.log("applyScrollOffset - home ", applyScrollOffset)
              // // if (panelContent) {

              //  console.log("pabel content on  home");
              panelContent.scrollTo({
                top: applyScrollOffset,
                behavior: 'smooth'
              });
              // } 
            }
          }

        });
      });

      // console.log("type is archive - so we need to add a link to the post");
      // console.log("postsItems", postsItems);
    } else if (type == "single") {


      //related posts
      // console.log("type is single - so...");
      // console.log("postsItems", postsItems);

      // this maybe be flawwed beccause on arhvie we load the post transform (old container markup) and then the article__content wiht the new toggle etc.
      postsItems.forEach((item) => {
        //  console.log("postsItems each", item);
        let linkTarget = item; //.querySelector('li[data-active-post]'); // this not existing on the arhice - revview reasonsing

        linkTarget.addEventListener('click', function (event) {

          // console.log("Cick event Listener");
          // console.log("linkTarget", linkTarget);
          // console.log("event.target", event.target);


          //chekc if theuser click the more like or the li - because if the url clickced we don't want to change classes etc

          let dataActivePost = linkTarget.getAttribute('data-post'); // this will be idle initially
          // console.log("Archive HERE: item linkTarget click", dataActivePost);
          let dataActivePostId = linkTarget.getAttribute('data-post-id'); // this will be idle initially
          // console.log("Archive HERE: item linkTarget click", dataActivePostId);
          // assigne active post id to body (for post transform and filtering in next namespace)
          document.querySelector('body').setAttribute('data-active-post', dataActivePostId); // this will be idle initiall


          if (event.target.tagName.toLowerCase() == 'a') {
            // we clicked a link 
            // this reutn statment needs propper chekcing = might cause issues tha tI'm not aware of
            // 22jun 2024
            // linkTarget.classList.add("--active"); // review

            // console.log("we clicked a link - so don't toggle the post content?");
            // console.log("but this hangs for ages- why?")
            return;
          } else if (event.target.tagName.toLowerCase() !== 'a') {
            // if not a link - then we need to toggle the post content
            // console.log("not a link - so toggle post content");

            if (linkTarget.classList.contains("--active")) {
              // this item is already active - so we need to close the side panel
              // console.log("item is not active anymore", linkTarget);
              linkTarget.classList.remove("--active");

            } else {
              // console.log("item is now active", linkTarget);

              postsItems.forEach((postsItem) => {
                // console.log("its remove here?");
                // postsItem.style.backgroundColor = "red";
                postsItem.classList.remove("--active");
              });

              //add active class to this item
              linkTarget.classList.add("--active");

            }

          }

          //review this in conjusction withte js abovve for the archive page
          let dataActivePostHeight = linkTarget.offsetHeight, // height of active item
            getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
            //adding 2px here - review if correct!
            applyScrollOffset = linkTarget.getBoundingClientRect().top + window.scrollY + (-parseInt(getScrollOffset, 10) * 3) + 3; // remove px and multiply by 3 (header/nav/title) -- but maybe not always the case?! chekc on mobile
          root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var



          // console.log("each resources posts; post items link target- applyScrollOffset in barba helpers", applyScrollOffset);


          // review this in its entiriry - it might be breaking the barba transitions

          if (document.querySelector('body').classList.contains('loading')) {
            console.log("document.querySelector('body')", document.querySelector('body'));

            // 22 jun - this affescts the home to archive transition - so I need to review this as well

          } else {
            //reivew this ensure it doesn't apply on home

            // console.log("/reivew this ensure it doesn't apply this scrolon home")
            // does this fix the issues?
            window.scrollTo({
              top: applyScrollOffset,
              behavior: 'smooth'
            });

          }

        });
      });

    }

  });

}

export function updateHeaderStyles(location, body) {

  console.log("updateHeaderStyles", body);
  console.log("location", location);


  let head = body.querySelector("header"); // main header
  let header = body.querySelector(".header__nav"); // nav container << review the usage of this!
  let headerNav = body.querySelector(".header-nav"); //actaul nav
  let headerLogo = body.querySelectorAll(".logo a"); //review usage of this selector - there are 2!


  const updateIntrotl = gsap.timeline({
    defaults: {
      duration: 0.5,
      ease: "power4.out",
    },
  });

  if (location == "home") {
    console.log("location is home"); // but we donn't want to fire this when are initially loading the intro
    // so maybe move this elsewhere - or add a check to see if the intro has been loaded?

    updateIntrotl
      .to(head, {
        background: "transparent",
      }, "<")
      .to(headerLogo, {
        opacity: 0,
      }, "<")

  } else if (location == "default") {
    console.log("location is default");

    updateIntrotl
      .to(head, {
        background: "white",
      }, "<")
      .to(headerLogo, {
        opacity: 1,
      }, "<")
  }

}


export function scrollBackToTop() {
  console.log("scrollBackToTop");
  // window.scrollTo({
  //   top: 0,
  //   left: 0,
  //   behavior: "smooth", // too slow atm?
  // });
  // instead of scroll just jump to the top
  window.scrollTo(0, 0);
}


export function scrollTopPost(linkTarget) {


  // review this - needs to scroll to 2 x header height; top header and the title; the nav panel needs to be remove at same tim; or opacity changed

  const panelContent = document.querySelector('.panel__content[data-panel-content=resources]'); // needs to be the active one? 

  let root = document.querySelector(':root'),
    dataActivePostHeight = linkTarget.offsetHeight, // height of active item
    getScrollOffset = getComputedStyle(root).getPropertyValue('--header-height'),
    // Adding 3 px - that resolves the iccorect offset - possibley because the borders are not mesauresd at?
    applyScrollOffset = linkTarget.getBoundingClientRect().top + panelContent.scrollTop + (-parseInt(getScrollOffset, 10) * 2) + 2; // remove px and multiply by 2 (header/nav/title) - ensure we canter for the border  (anbd visbility of them)

  root.style.setProperty('--active-item-height', dataActivePostHeight + "px"); //set active item height as var


  // ensure panel is in the correct position for next phase in barba transitions
  panelContent.scrollTo({
    top: applyScrollOffset,
    behavior: 'smooth'
  });

  // This function doesn't consider or adress the following atm:
  // review if this is the only issue - adress holistically


  // 1. if its the bottom item; there is no more scrolling availabel to move up the nav height
  // that means we nee dto add more space - or move up using a margin instead/in addition?
}